import { useEffect, useRef } from 'react';
import type { Command } from '@atlassian/jira-command-palette';
import type { useRegisterCommands } from '@atlassian/jira-command-palette-registry';
import { useSubscribeChildCommands } from '../use-subscribe-child-commands';

// We aren't using the dep list to avoid issues with it in future
export const useRegisterChildCommands: typeof useRegisterCommands = (
	_: string,
	commands: Command[],
) => {
	const subscribe = useSubscribeChildCommands();

	const commandCache = useRef(commands);

	useEffect(() => {
		commandCache.current = commands;
	}, [commands]);

	useEffect(() => subscribe(commandCache.current), [commands, subscribe]);
};
